import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.8,
		y: 15.2,
		width: 12.4,
		height: 5.4,
		rx: 1.2,
		transform: "rotate(-90 1.8 15.2)",
		stroke: "currentColor",
		strokeWidth: 1.6
	}), /* @__PURE__ */ _jsx("rect", {
		x: 10.8,
		y: 15.2,
		width: 12.4,
		height: 5.4,
		rx: 1.2,
		transform: "rotate(-90 10.8 15.2)",
		stroke: "currentColor",
		strokeWidth: 1.6
	})]
});
export default SvgIconProjects;
